"use client";

import React from "react";

//Styled
import * as S from "./styles";
import { DictionaryProps } from "@/types";

//Image
//import LogoNight from '@/assets/images/simpleLogo.png';
//import LogoDay from '@/assets/images/simpleLogoDay.png';
import LogoNight from "@/assets/images/logoSimple.png";
import LogoDay from "@/assets/images/logoSimple.png";
import { useTheme } from "next-themes";
import { HomeIcon } from "lucide-react";

const NotFoundPage: React.FC<DictionaryProps> = ({ dict }) => {
  const { theme } = useTheme();

  const Logo = theme === "dark" ? LogoNight : LogoDay;

  return (
    <S.BoxNotFound>
      <S.BoxContentNotFound>
        <S.Link href="/">
          <S.ImageComponent src={Logo} />
        </S.Link>
        {/* <S.NotfoundIcon/> */}
        <S.TitleFound>404</S.TitleFound>
        <S.Descirption>{dict["Page not found"]}</S.Descirption>
        <S.SmallDescirption>
          {
            dict[
              "Oops! It looks like the page you're looking for doesn't exist or has been removed. Please go back to the home page or check the address you entered"
            ]
          }
        </S.SmallDescirption>
        <S.BackToHomeButton href="/">
          {" "}
          <HomeIcon /> {dict["Back to home page"]}{" "}
        </S.BackToHomeButton>
      </S.BoxContentNotFound>
    </S.BoxNotFound>
  );
};

export default NotFoundPage;
